import { Canvas, useFrame } from "@react-three/fiber";
import { Suspense, useRef } from "react";
import { Float } from "@react-three/drei";

function Knot({ color }) {
  const r = useRef(null);
  useFrame((s) => {
    if (!r.current) return;
    const t = s.clock.getElapsedTime();
    r.current.rotation.x = t * 0.25;
    r.current.rotation.y = t * 0.35;
  });
  return (
    <Float speed={1.2} rotationIntensity={0.4} floatIntensity={0.8}>
      <mesh ref={r}>
        <torusKnotGeometry args={[1.1, 0.32, 220, 32]} />
        <meshStandardMaterial
          color={color}
          emissive={color}
          emissiveIntensity={0.25}
          wireframe
        />
      </mesh>
    </Float>
  );
}

export default function AboutScene({ theme = "dark" }) {
  const isLight = theme === "light";
  const color = isLight ? "#5a7d00" : "#ccff00";
  const accent = isLight ? "#cc3300" : "#ff4500";
  return (
    <Canvas
      key={theme}
      dpr={[1, 1.5]}
      camera={{ position: [0, 0, 4.5], fov: 50 }}
      gl={{ antialias: true, alpha: true }}
    >
      <ambientLight intensity={isLight ? 0.6 : 0.4} />
      <pointLight position={[3, 3, 3]} intensity={2} color={accent} />
      <pointLight position={[-3, -3, 2]} intensity={1.4} color={color} />
      <Suspense fallback={null}>
        <Knot color={color} />
      </Suspense>
    </Canvas>
  );
}
